import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { Box, Flex, COLORS, Spinner } from '@podiumhq/design-system';
import useMediaQuery from 'hooks/useMediaQuery';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';

const LOADING_INTERVAL = 2500;

const CreatingBusinessNumber = () => {
  const loadingMessages = [
    'We’re building a consolidated Inbox to rule them all.',
    'We’re creating text templates so you can just hit “Send.”',
    'We’re creating a chat tool for your website.',
    'We’re generating your new, textable Podium number.',
  ];

  const isMobile = useMediaQuery();
  const [index, setIndex] = useState(0);

  const changeLoadingText = () => {
    let i = 0;
    const timer = setInterval(() => {
      if (i < 4) setIndex(i + 1);
      else setIndex(0);

      if (++i === 3) clearInterval(timer);
    }, LOADING_INTERVAL);
    return;
  };

  useEffect(() => {
    changeLoadingText();
  }, []);

  return (
    <>
      {isMobile ? (
        <Wrapper>
          <LoadingIcon>
            <Spinner size="md" speed="0.5s" />
          </LoadingIcon>
          <SpinnerText>{loadingMessages[index]}</SpinnerText>
        </Wrapper>
      ) : (
        <Flex justifyContent="center">
          <Box
            position="fixed"
            zIndex="10"
            top="50%"
            margin="18px"
            transform="translate(0, -50%)"
            background="white"
            boxShadow="0px 0px 0px 0.5px rgba(18, 21, 26, 0.08),
	0px 8px 16px rgba(18, 21, 26, 0.02),
	0px 16px 32px -4px rgba(18, 21, 26, 0.04),
	0px 32px 64px -8px rgba(18, 21, 26, 0.04)"
            borderRadius="16px"
            padding="90px"
            width="512px"
            height="325px"
          >
            <Animate>
              <LoadingIcon>
                <Spinner size="md" speed="0.5s" />
              </LoadingIcon>
              <SpinnerText>{loadingMessages[index]}</SpinnerText>
            </Animate>
          </Box>
        </Flex>
      )}
    </>
  );
};

export const Animate = styled.div`
  animation: wiggleWiggle 0.25s ease-in-out;
  @keyframes wiggleWiggle {
    0% {
      transform: translateX(24px);
      opacity: 0;
    }
    50% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const LoadingIcon = styled.div`
  width: 72px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
`;

const SpinnerText = styled.p`
  font-weight: 500;
  font-size: 20px;
  line-height: 150%;
  color: ${COLORS.black.lighter};
  text-align: center;

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    color: ${COLORS.silver.lighter};
  }
`;

const Wrapper = styled.div`
  padding-top: 32vh;
  background: #1e47f6;
  height: 100vh;
  padding-left: 24px;
  padding-right: 24px;
  margin: -24px;
`;

export default CreatingBusinessNumber;
